import './body-lead.modules.scss';

interface BodyLeadProps {
    text: string;
}

export default function BodyLead(props: BodyLeadProps) {
    return <div className={'body-lead'}>{props.text}</div>;
}
